export default __webpack_public_path__ + "static/media/sf8.2f2dfcb6.jpeg";